import { gql } from '@apollo/client';

/**
 * Get all talent favorites for the authenticated Upercut user
 * Supports filtering, sorting, and pagination
 */
export const GET_TALENT_FAVORITES_UPERCUT = gql`
    query GetTalentFavoritesUpercut(
        $query: String
        $filter: TalentFavoriteFilterUpercut
        $sortBy: TalentFavoriteSortBy
        $pagination: Pagination
    ) {
        getTalentFavoritesUpercut(
            query: $query
            filter: $filter
            sortBy: $sortBy
            pagination: $pagination
        ) {
            docs {
                _id
                talent {
                    _id
                    slug
                    fullName
                    email
                    city
                    logo
                    photo
                    active
                    yearsOfExperience
                    upercutAverageRating
                    upercutRatings {
                        _id
                        upercutId
                        rating
                        createdAt
                    }
                    upercutNotes {
                        _id
                        upercutId
                        note
                        title
                        visibility
                        createdAt
                    }
                    upercutFavorites {
                        _id
                        talentId
                        type
                        metadata {
                            notes
                            tags
                            priority
                            campaign
                        }
                        createdAt
                    }
                    currentStatusUser
                    roleDescription
                    isActiveStatusUser
                    expectedSalary
                    preferences
                    createdAt
                    profilePicture {
                        url
                    }
                    resume {
                        path
                        name
                        mimetype
                    }
                    files {
                        _id
                        name
                        path
                        context
                        size
                        url
                        mimetype
                    }
                    jobApplications {
                        _id
                        # source
                        jobOffer {
                            title
                            city
                            brand {
                                brandName
                                brandLogo {
                                    url
                                }
                            }
                        }
                    }
                    experiences {
                        _id
                        title
                    }
                    diplomas {
                        _id
                        title
                        type
                    }
                    certificates {
                        _id
                        title
                    }
                }
                type
                metadata {
                    notes
                    tags
                    priority
                    campaign
                }
                createdAt
                updatedAt
            }
            meta {
                totalDocs
                totalPages
                page
                limit
                hasNextPage
                hasPrevPage
            }
        }
    }
`;

/**
 * Check if specific talents are favorited by the authenticated Upercut user
 */
export const CHECK_TALENT_FAVORITE_STATUS_UPERCUT = gql`
    query CheckTalentFavoriteStatusUpercut($talentIds: [ID!]!) {
        checkTalentFavoriteStatusUpercut(talentIds: $talentIds) {
            talentId
            isFavorite
            favoriteType
            metadata {
                notes
                tags
                priority
                campaign
            }
            favoriteCreatedAt
        }
    }
`;

/**
 * Add one or more talents to favorites for the authenticated Upercut user (bulk)
 */
export const ADD_TALENT_FAVORITE_UPERCUT = gql`
    mutation AddTalentFavoriteUpercut($input: AddTalentFavoriteUpercutInput!) {
        addTalentFavoriteUpercut(input: $input) {
            _id
            talent {
                _id
                firstName
                lastName
            }
            type
            metadata {
                notes
                tags
                priority
                campaign
            }
            createdAt
        }
    }
`;

/**
 * Remove a talent from favorites for the authenticated Upercut user
 */
export const REMOVE_TALENT_FAVORITE_UPERCUT = gql`
    mutation RemoveTalentFavoriteUpercut($favoriteId: ID!) {
        removeTalentFavoriteUpercut(favoriteId: $favoriteId)
    }
`;

/**
 * Toggle talent favorite status (add if not favorited, remove if favorited)
 */
export const TOGGLE_TALENT_FAVORITE_UPERCUT = gql`
    mutation ToggleTalentFavoriteUpercut($input: ToggleTalentFavoriteUpercutInput!) {
        toggleTalentFavoriteUpercut(input: $input) {
            isFavorite
            favorite {
                _id
                type
                metadata {
                    notes
                    tags
                    priority
                    campaign
                }
            }
            talent {
                _id
                firstName
                lastName
                email
            }
        }
    }
`;

/**
 * Batch update talent favorites (add/remove multiple types in single transaction)
 */
export const BATCH_UPDATE_TALENT_FAVORITES_UPERCUT = gql`
    mutation BatchUpdateTalentFavoritesUpercut($input: BatchUpdateTalentFavoritesInput!) {
        batchUpdateTalentFavoritesUpercut(input: $input) {
            added {
                _id
                type
                metadata {
                    notes
                    tags
                    priority
                    campaign
                }
                createdAt
            }
            removed
        }
    }
`;
